export const handleGoogleMapRedirect = (city: string) => {
  const url = `https://www.google.com/maps/place/${encodeURIComponent(city)}`;
  window.open(url, '_blank');
};
